import { upperSnakeCaseToLowerCase } from './upperSnakeCaseToLowerCase';

export function getWarningText(parsedDetails) {
  if (parsedDetails.warningType) {
    return upperSnakeCaseToLowerCase(parsedDetails.warningType);
  } else return '';
}
